'use client'

import { buttonCls } from '@qr-front/ui/components/Button'
import { cn, getVersionForClone } from '@qr-front/ui/utils'
import { ROUTES } from 'constants/routesConstants'
import { useAtomValue } from 'jotai'

import { isAuthenticatedAtom } from '@/global-state'
import { Link, usePathname } from '@/i18n-routing'

export const HeaderDesktopLinks = ({
	translations,
}: {
	translations: {
		loginButtonLabel: string
		createButtonLabel: string
		signUpButton: string
	}
}) => {
	const pathname = usePathname()
	const isAuthenticated = useAtomValue(isAuthenticatedAtom)

	const pathnameMatchesAltLanding = pathname === ROUTES.altLanding

	if (pathnameMatchesAltLanding) {
		return null
	}

	const createButton = (
		<Link
			href={ROUTES.generator.typeStep}
			className={cn(
				buttonCls(
					getVersionForClone({
						base: { visual: 'soft' },
						clone1: { visual: 'default' },
					}),
				),
				getVersionForClone({
					base: 'hover:bg-blue hover:text-white',
					clone1: 'type-button-small bg-black',
				}),
			)}
		>
			{translations.createButtonLabel}
		</Link>
	)

	return (
		<>
			{getVersionForClone({
				base: (
					<div className="divider h-5 w-px rounded-full bg-border-grey" />
				),
				clone1: null,
			})}
			{!isAuthenticated && (
				<Link
					href={ROUTES.auth.login}
					className={cn(
						buttonCls({
							visual: getVersionForClone({
								base: 'ghost',
								clone1: 'secondary',
							}),
						}),
						getVersionForClone({
							base: '',
							clone1: 'type-button-small',
						}),
					)}
				>
					{translations.loginButtonLabel}
				</Link>
			)}
			{createButton}
		</>
	)
}
